import { createComponentPreviewMapperModel } from '@wix/editor-elements-integrations';
import { composeMapper } from '@wix/editor-elements-preview-utils';
import type { PreviewWrapperProps } from '@wix/editor-elements-types/thunderboltPreview';

import type {
  TextOnPathDefinition,
  TextOnPathPreviewWrapperProps,
} from '../TextOnPath.types';
import { props as viewerPropsMapper } from './TextOnPath.mapper';

const props = composeMapper<
  PreviewWrapperProps<{
    previewWrapperProps?: TextOnPathPreviewWrapperProps;
  }>,
  TextOnPathDefinition
>()(
  viewerPropsMapper,
  { add: ['isPlayingAllowed', 'styleProperties', 'compData'] },
  (resolver, deps, carmiProps) => {
    const viewerProps = resolver(deps, carmiProps);
    const { isPlayingAllowed, styleProperties, compData } = deps;

    return {
      ...viewerProps,
      animate: isPlayingAllowed,
      previewWrapperProps: {
        font: styleProperties.font,
        text: compData.text,
        fillMode: compData.fillMode,
      },
    };
  },
);

export default createComponentPreviewMapperModel({
  props,
});
